<template>
  <div class="sidebar" :key="renderSidebar">
    <div class="sidebar__viewport">
      <div class="sidebar__viewport__menu">
        <header class="sidebar__viewport__menu--header">
          <div class="sidebar__viewport__menu--header--img"></div>
        </header>
        <ul class="nav">
          <li
            v-if="currentDepartment.rol_name == 'superuser'"
            id="usersManagement"
            class="nav--item"
            @click="redirectionClick('UsersManagement')"
          >
            <router-link :to="{ name: 'UsersManagement' }">
              <i class="fa fa-users-cog fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">Users</span>
          </li>
          <li
            v-if="currentDepartment.rol_name == 'quoter'"
            id="myQueue"
            class="nav--item"
            @click="redirectionClick('Emails', 'myQueue')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'myQueue' } }"
            >
              <i class="fa fa-house-user fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">My queue</span>
          </li>
          <li
            id="queue"
            class="nav--item"
            @click="redirectionClick('Emails', 'queue')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'queue' } }"
            >
              <i class="fa fa-list-ul fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">Queue</span>
          </li>
          <li
            v-if="currentDepartment.department_id == 1"
            id="spanish-queue"
            class="nav--item"
            @click="redirectionClick('Emails', 'spanish-queue')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'spanish-queue' } }"
            >
              <i class="fa fa-list-ul fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">SP Queue</span>
          </li>
          <li
            id="inProcess"
            class="nav--item"
            @click="redirectionClick('Emails', 'inProcess')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'inProcess' } }"
            >
              <i class="fa fa-spinner fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">In Process</span>
          </li>
          <li
            v-if="currentDepartment.department_id == 1"
            id="hypercubes"
            class="nav--item"
            @click="redirectionClick('Emails', 'hypercubes')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'hypercubes' } }"
            >
              <i class="fa fa-cube"></i> <br />
            </router-link>
            <span class="nav--item--name">Hypercubes</span>
          </li>
          <li
            v-if="
              currentDepartment.rol_name == 'superuser' &&
                currentDepartment.department_id == 1
            "
            id="alerts"
            class="nav--item"
            @click="redirectionClick('Emails', 'alerts')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'alerts' } }"
            >
              <i class="fa fa-bell"></i> <br />
            </router-link>
            <span class="nav--item--name">Alerts</span>
          </li>
          <li
            id="failed"
            class="nav--item"
            @click="redirectionClick('Emails', 'failed')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'failed' } }"
            >
              <i class="fa fa-times-circle fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">Failed</span>
          </li>
          <li
            id="sent"
            class="nav--item"
            @click="redirectionClick('Emails', 'sent')"
          >
            <router-link :to="{ name: 'Emails', params: { pathName: 'sent' } }">
              <i class="fa fa-paper-plane fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">Sent</span>
          </li>
          <li
            id="unknown"
            class="nav--item"
            @click="redirectionClick('Emails', 'unknown')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'unknown' } }"
            >
              <i class="fa fa-exclamation fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name"
              >Non {{ nameDepartment.toUpperCase() }}</span
            >
          </li>
          <li
            id="deleted"
            class="nav--item"
            @click="redirectionClick('Emails', 'deleted')"
          >
            <router-link
              :to="{ name: 'Emails', params: { pathName: 'deleted' } }"
            >
              <i class="fa fa-trash-alt fa-sm"></i> <br />
            </router-link>
            <span class="nav--item--name">Deleted</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MenuSidebar",
  data() {
    return {
      currentDepartment: null,
      renderSidebar: 0,
      nameDepartment: null
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes", ["showActualQueue"])
  },
  watch: {
    showInfoDepartment(value) {
      this.currentDepartment = value;
      this.renderSidebar += 1;
      let path;
      if (this.$route.path == "/usersManagement") {
        path = "usersManagement";
      } else {
        path = "queue";
      }
      document.getElementById(path).style.background =
        "rgba(171, 178, 185, 0.3)";
      this.getNameDepartment();
    },
    "$route.params.pathName": function(newValue, oldValue) {
      let path;
      let old;
      if (newValue == undefined && this.$route.path == "/usersManagement") {
        path = "usersManagement";
        old = oldValue;
      } else if (
        oldValue == undefined &&
        this.$route.path !== "/usersManagement"
      ) {
        old = "usersManagement";
        path = newValue;
      } else {
        path = newValue;
        old = oldValue;
      }
      document.getElementById(path).style.background =
        "rgba(171, 178, 185, 0.3)";
      document.getElementById(old).style.background = "none";
    },
    showActualQueue() {
      this.getQueueName(this.showActualQueue);
    }
  },
  beforeMount() {
    this.currentDepartment = this.showInfoDepartment;
    this.getNameDepartment();
  },
  mounted() {
    let path;
    if (this.$route.path == "/usersManagement") {
      path = "usersManagement";
    } else {
      path = this.$route.params.pathName;
    }
    document.getElementById(path).style.background = "rgba(171, 178, 185, 0.3)";
  },
  methods: {
    redirectionClick(routerName, urlName) {
      this.$router
        .push({ name: routerName, params: { pathName: urlName } })
        .catch(err => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // logError(err);
          }
        });
      //Revisar si es necesario esta mutación en vuex
      // this.$store.commit("quotes/setKeyComponent");
    },
    getQueueName(name) {
      switch (name) {
        case "ftl":
          this.nameDepartment = "FTL";
          break;
        case "drayage":
          this.nameDepartment = "Drayage";
          break;
      }
    },
    getNameDepartment() {
      if (this.currentDepartment.department_id == 2) {
        this.nameDepartment = this.showActualQueue;
      } else {
        this.nameDepartment = this.currentDepartment.department_name;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar__viewport__menu {
  z-index: 1000;
  position: fixed;
  left: 250px;
  top: 0;
  width: 5%;
  height: 100%;
  margin-left: -250px;
  overflow-y: auto;
  background: $color-background-dark;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;

  &--header {
    padding: 10% 0%;
    background-color: $color-background-darker;
    line-height: 52px;
    text-align: center;
    &--img {
      @include justify-items-center;
      content: url("../"+$image-company);
      width: 90%;
    }
    a:hover {
      color: $color-white;
    }
  }

  .nav {
    margin-top: $margin-most-used/2;
    a {
      background: none;
      color: #cfd8dc;
      &:hover {
        color: $color-background-input;
      }
    }
    i {
      margin-right: 16px;
    }

    &--item {
      width: 100%;
      padding: 10%;
      &:hover {
        background: rgba(171, 178, 185, 0.3) !important;
        cursor: pointer;
      }
      &--name {
        font-size: 0.7vw;
        color: $color-light;
      }
    }
  }
}

@media (max-width: 1400px) {
  .sidebar__viewport__menu {
    width: 7%;
    &--header {
      padding: 0;
    }
    .nav--item {
      padding: 5%;
      &--name {
        font-size: 11px !important;
      }
    }
  }
}
</style>
